<script>
import { calculate, isEmptyObject } from '@/helpers'

window.calculate = calculate

window.objectParametize = obj => {
  return Object.entries(obj)
    .map(([key, val]) => `${key}=${val}`)
    .join('&')
}

function getIfExist(target, path, defaultValue = undefined) {
  try {
    if (path.length > 0 && path.charAt(0) !== '[') path = '.' + path

    const value = eval('target' + path)

    return value === undefined ? defaultValue : value
  } catch (e) {
    return defaultValue
  }
}

window.getIfExist = getIfExist

export default {
  data() {
    return {
      app: window.app,
      componentLoading: {
        active: true,
        text: 'Carregando...',
      },
      noInternet: {
        online: undefined,
      },
      timers: {},

      log: {
        name: this?.$options?.name ?? this?.$route?.name,
        colors: {
          info: [
            //'background: green',
            'color: #00A0C1',
          ].join(';'),

          success: [
            //'background: green',
            'color: green',
          ].join(';'),
        },

        print: process.env.NODE_ENV === 'development',

        info(obj) {
          if (this.print === true)
            console.info(`%c[${this.name}] ${obj}`, this.colors.info)
        },

        success(obj) {
          if (this.print === true)
            console.log(`%c[${this.name}] ${obj}`, this.colors.success)
        },

        error(obj) {
          if (this.print === true) console.error(`[${this.name}]`, obj)
        },

        warn(obj) {
          if (this.print === true) console.warn(`[${this.name}]`, obj)
        },
      },
    }
  },

  computed: {
    isComponentRoute() {
      const matched = this.$route?.matched ?? []
      const routeMatchComponentName =
        matched[matched.length - 1]?.components?.default?.name
      const currentComponentName = this.$options?.name

      return currentComponentName === routeMatchComponentName
    },
  },

  beforeDestroy() {
    this.stopAllTimers()
  },

  methods: {
    async stopAllTimers() {
      const timers = this.timers

      if (isEmptyObject(timers) === false) {
        this.log?.info?.(`Interrompendo todos os timers...`)

        if (timers) Object.keys(timers).forEach(this.stopInterval)

        this.log?.success?.(`Timers interrompidos com sucesso!`)
      }
    },

    async stopInterval(name) {
      const timers = this.timers

      if (timers[name]) {
        this.log?.info?.(`Parando o timer ${name}...`)

        clearInterval(timers[name])

        delete this.timers[name]

        this.log?.success?.(`Timer ${name} interrompido com sucesso!`)
      }
    },

    async setInterval({ name, delay, func, immediate = false }) {
      const timers = this.timers

      this.stopInterval(name)

      this.log?.info?.(`Iniciando timer ${name}...`)

      if (!timers) this.timers = {}

      timers[name] = setInterval(func, delay)

      if (immediate === true) func()

      this.log?.success?.(`Timer ${name} iniciado com sucesso!`)

      return timers
    },

    getInParents(path) {
      let parent = this.$parent

      while (parent) {
        const result = getIfExist(parent, path)

        if (result !== undefined) return result
        else parent = parent.$parent
      }
    },

    findComponentInParent(name) {
      let parent = this.$parent

      while (
        parent &&
        [parent.$options.name, parent.$options._componentTag].includes(name) ===
          false
      )
        parent = parent.$parent

      return parent
    },
  },
}
</script>
